import {
  Link as ReactRouterLink,
  type LinkProps as ReactRouterLinkProps,
} from 'react-router';

export type RouterLinkProps = ReactRouterLinkProps & {
  /** if `true`, attaches a click handler with preventDefault */
  disabled?: boolean;
};

/**
 * A react-router Link component with an added `disabled` prop.
 *
 * @param disabled if `true`, attaches a click handler with preventDefault
 *
 * @see https://reactrouter.com/api/components/Link
 */
export const RouterLink = ({
  children,
  disabled,
  onClick,
  ...props
}: RouterLinkProps) => (
  <ReactRouterLink
    {...props}
    data-disabled={disabled || undefined}
    onClick={(e) => {
      if (disabled) return e.preventDefault();
      onClick?.(e);
    }}
  >
    {children}
  </ReactRouterLink>
);
